import { EquipmentRequestStatusEnum } from "../../../../graphql/graphQlApiHooks";


export const getAvailableStatuses = (): EquipmentRequestStatusEnum[] => {
    return [
        EquipmentRequestStatusEnum.Submitted,
        EquipmentRequestStatusEnum.Pending,
        EquipmentRequestStatusEnum.DocumentPackageFormation,
        EquipmentRequestStatusEnum.ContractingServiceAndPlanningAndEconomicDepartmentApproval,
        EquipmentRequestStatusEnum.LotFormation,
        EquipmentRequestStatusEnum.Auction,
        EquipmentRequestStatusEnum.Acceptance,
        EquipmentRequestStatusEnum.EquipmentAccepted,
        EquipmentRequestStatusEnum.PassedToAno,
        EquipmentRequestStatusEnum.PassedToContractualService,
        EquipmentRequestStatusEnum.Rejected 
    ];
};